var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{class:_vm.className,attrs:{"rules":_vm.rules,"name":(_vm.tab + "." + _vm.field)},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
var errors = ref.errors;
var changed = ref.changed;
return [_c('b-form-select',{attrs:{"state":_vm.onValidateField(valid, errors, changed),"value":_vm.getField,"options":_vm.options},on:{"input":_vm.updateField}}),_c('b-form-invalid-feedback',{attrs:{"id":"inputLiveFeedback"}},[_vm._v(_vm._s(errors[0]))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }